import { render, staticRenderFns } from "./node-area-edit.vue?vue&type=template&id=72ed21b0&scoped=true&"
import script from "./node-area-edit.vue?vue&type=script&lang=js&"
export * from "./node-area-edit.vue?vue&type=script&lang=js&"
import style0 from "./node-area-edit.vue?vue&type=style&index=0&id=72ed21b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ed21b0",
  null
  
)

export default component.exports